import { EventInterface } from '@splidejs/splide';

export default function FadeTransition(Splide, Components) {
  const { bind } = EventInterface(Splide);
  const { Move } = Components;
  const { list } = Components.Elements;

  let endCallback;

  function cancel() {
    list.style.transition = '';
  }

  function mount() {
    bind(list, 'transitionend', (e) => {
      if (e.target === list && endCallback) {
        // Removes the transition property
        cancel();
      }
    });
    bind(list, 'transitionstart', () => {
      // Calls the `done` callback
      if (typeof endCallback === 'function') {
        endCallback();
      }
    });
  }

  function start(index, done) {
    // Converts the index to the position
    const destination = Move.toPosition(index, true);

    // Applies the CSS transition
    list.style.transition = 'transform 800ms cubic-bezier(.44,.65,.07,1.01)';

    // Moves the slider to the destination.
    Move.translate(destination);

    // Keeps the callback to invoke later.
    endCallback = done;
  }

  return {
    mount,
    start,
    cancel,
  };
}
